import { useEffect } from 'react';
import { AppLoaderOverlay } from './shared/AppLoader.js';
import { InterviewGeneratingOverlay } from './setup/InterviewGeneratingOverlay.js';
import { useUiStore } from '../store/uiStore.js';

export function GlobalLoader() {
  const isGlobalLoading = useUiStore((state) => state.isGlobalLoading);
  const loadingMessage = useUiStore((state) => state.loadingMessage);
  const loadingVariant = useUiStore((state) => state.loadingVariant);

  useEffect(() => {
    if (!isGlobalLoading) return;

    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, [isGlobalLoading]);

  if (!isGlobalLoading) return null;

  if (loadingVariant === 'simulation') return <InterviewGeneratingOverlay />;

  return <AppLoaderOverlay message={loadingMessage} />;
}
